<template>
    <div class="integralConvert">
        <!--<div class="memberRuleNav">-->
            <!--<i class="iconfont iconzuojiantou" @click="returnFn"></i>-->
        <!--</div>-->
        <div class="integealConvertContent">
            <div class="scrollContent">
                <md-field >
                    <md-field-item>
                        当前积分：<span class="integralNum">{{userData.cardScore}}</span>
                        <span slot="right" class="ticketName" v-if="iticketData.cardType == '001'">商场券</span>
                        <span slot="right" class="ticketName" v-if="iticketData.cardType == '002'">品牌券</span>
                        <span slot="right" class="ticketName" v-if="iticketData.cardType == '003'">停车券</span>
                    </md-field-item>
                    <md-field-item>
                        兑换积分：<span class="intdgralNum2">{{iticketData.ticketScore}}</span>
                        <span slot="right" class="ticketName">面值：{{iticketData.subTitile}}元</span>
                    </md-field-item>
                    <!--<md-field-item title="兑换数量：" v-if="iticketData.checkTag === '1'">-->
                        <!--&lt;!&ndash;iticketData.checkNum>0?1:0&ndash;&gt;-->
                        <!--<md-stepper slot="left" :min="0" v-model="iticketNum" :max="iticketData.checkNum" :disabled="iticketData.checkNum==0" />-->
                        <!--&lt;!&ndash;<div slot="right" class="num-table">{{iticketData.checkNum==0?"已领取完":'剩余数量：'+iticketData.checkNum}}</div>&ndash;&gt;-->
                    <!--</md-field-item>-->
                    <md-field-item title="兑换数量：" >
                        <md-stepper slot="left" :min="0" :max="99" v-model="iticketNum" />
                        <!--<div slot="right" class="num-table" >不限领取</div>-->
                    </md-field-item>
                    <md-field-item title="有效日期：">
                        {{iticketData.beginDate}} ~ {{iticketData.endDate}}
                    </md-field-item>
                    <md-input-item
                            title="手机号码："
                            type="phone"
                            :maxlength="11"
                            v-model="userData.phone"
                            disabled
                    ></md-input-item>
                    <md-input-item
                            title="验证号码："
                            type="text"
                            v-model="vcode"
                            @blur="onBlur"
                    >
                        <div class="operatorNum" v-if="securityState" slot="right" >{{num}}s</div>
                        <div class="input-operator" @click="securityCodeFn" v-else slot="right" >获取验证码</div>
                    </md-input-item>
                </md-field>
                <div class="item-member">
                    <div class="itemTitle">
                        兑换须知：
                    </div>
                    <div class="item-member-main">
                        {{iticketData.ticketInfo}}
                    </div>
                </div>
            </div>
            <div class="convertBtn" @click="gotoIntegralTicketVerifyFn">我要兑换</div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "integralTicketConvert",
        data(){
          return {
              securityState:false, //验证码显示状态
              num:60, //验证码时间
              iticketData:'', //卡券信息
              userData:'', //用户信息
              iticketNum:1,//领券数量
              vcode:'', //短信验证码
              wei:6,//验证码位数
          }
        },
        created(){
            this.iticketData = JSON.parse(this.$route.query.itemData)

            this.userData = JSON.parse(localStorage.getItem("userData"))
        },
        mounted() {
            document.title = "积分换券"
        },
        methods:{
            onBlur(){
                document.body.scrollTop = 0;
            },
            // returnFn(){
            //     this.$router.go(-1)
            // },
            gotoIntegralTicketVerifyFn(){ //兑换
                if(this.vcode.length != this.wei){
                    this.UI.Toast.failed(`请输入正确的验证码（${this.wei}位）`)
                    return
                }
                let dt = new URLSearchParams()
                let {title, subTitile, cardType, batchNo, ticketScore} = this.iticketData
                // let newJf = this.iticketNum*ticketScore //积分
                dt.append('openid', this.userData.wxOpenId)
                dt.append('title', title)
                dt.append('subtitle', subTitile)
                dt.append('type', cardType)
                dt.append('batchNo', batchNo)
                dt.append('num', this.iticketNum)
                dt.append('vcode', this.vcode)
                dt.append('score', ticketScore)

                this.$http.post('/sangto-wrm/vip/scoreCoupons/score2ErpCoupons', dt).then(({data})=>{
                    if(data.code == -1){
                        this.UI.Toast.failed(data.message)
                    }else{
                        //兑换完成更新会员积分
                        let openid = this.userData.wxOpenId
                        let dt = new URLSearchParams()
                        dt.append('openid',openid)
                        this.$http.post('/sangto-wrm/vip/member/getByOpenId',dt).then(({data})=>{ //使用openid获取会员信息
                            if(data.code == 200 && data.data != null){
                                let dataStr = JSON.stringify(data.data)
                                localStorage.setItem("userData", dataStr)
                            }else{
                                this.UI.Toast.failed(data.message)
                            }
                        })
                        this.UI.Dialog.alert({
                            content: data.message,
                            confirmText: '确定',
                            onConfirm: () =>{
                                this.$router.push({path:'/appMain/integralTicket'})
                            }
                        })

                    }

                })

            },
            securityCodeFn(){//获取验证码
                //这里判断手机号是否存在
                let jf = this.userData.cardScore //会员积分
                let newJf = this.iticketNum * this.iticketData.ticketScore
                if(jf < newJf){
                    this.UI.Toast.failed("积分值不够，无法兑换")
                    return
                }
                if(this.iticketNum == 0){
                    this.UI.Toast.failed("无兑换数量")
                    return
                }
                this.securityState = true
                this.stop = setInterval(()=>{
                    if(this.num == 0){
                        clearInterval(this.stop)
                        this.securityState = false
                        this.num = 60
                    }else{
                        this.num--
                    }
                },1000)
                let dt = new URLSearchParams()
                let {title, subTitile, cardType, batchNo} = this.iticketData
                dt.append('openid', this.userData.wxOpenId)
                dt.append('title', title)
                dt.append('subtitle', subTitile)
                dt.append('type', cardType)
                dt.append('batchNo', batchNo)
                dt.append('num', this.iticketNum)

                this.$http.post('/sangto-wrm/vip/scoreCoupons/getScore2CouponsNum', dt).then(({data})=>{ //判断是否可以兑换券

                    if(data.code == -100){
                        this.UI.Toast.failed(data.message)
                        return
                    }else{
                        let mes = new URLSearchParams()
                        mes.append('phone', this.userData.phone) //手机
                        mes.append('id', this.userData.wxOpenId) //用户id
                        mes.append('num', this.wei) //验证码位数
                        this.$http.post('/system/base/securityCode/message', mes).then(()=>{ //获取验证码

                        })
                    }
                })
            },
        }
    }
</script>

<style lang="scss" scoped>
.integralConvert{
    width: 100%;
    height: 100%;
    background-color: #fff;
    /*.memberRuleNav{*/
        /*width: 100%;*/
        /*height: 45px;*/
        /*background-color: #6cf;*/
        /*box-shadow: 0 1px 4px 0 rgba(0,0,0,0.1);*/
        /*line-height: 45px;*/
    /*}*/
    /*.iconzuojiantou{*/
        /*font-size: 24px;*/
        /*color: #fff;*/
        /*margin-left: 4px;*/
        /*padding: 6px;*/
    /*}*/
    .integealConvertContent{
        position: absolute;
        /*top: 45px;*/
        top: 0;
        left: 0;
        right: 0;
        bottom: 0px;
        overflow-x: hidden;
        overflow-y: auto;
    }
    .scrollContent{
        width: 100%;
    }
    .num-table{
        margin-right: 10px;
    }
    .item-member{
        width: 90%;
        margin: auto;
        display: flex;
    }
    .itemTitle{
        flex: none;
        width: 81px;
    }
    .item-member-main{
        flex: 1;
        line-height: 24px;
        font-size: 16px;
        color: #555;
    }
    .convertBtn{
        width: 88%;
        height: 45px;
        line-height: 45px;
        background-color:#4c9ee3;
        color: #fff;
        margin:60px auto 0 auto;
        text-align: center;
        border-radius: 5px;
        letter-spacing: 1px;
    }
    .input-operator{
        margin-right: 11px;
        width: 100px;
        height: 34px;
        background-color: #26a5ff;
        text-align: center;
        line-height: 34px;
        color: #fff;
        border-radius: 4px;
        font-size: 14px;
    }
    .operatorNum{
        margin-right: 11px;
        width: 60px;
        height: 34px;
        text-align: center;
        line-height: 34px;
        color: #ea5a59;
        border-radius: 4px;
        font-size: 14px;
    }
    .ticketName{
        margin-right: 10px;
    }
    .integralNum{
        color: #dc302f;
    }
    .intdgralNum2{
        color: lightseagreen;
    }
}
</style>
